import type { SubscriptionOverviewResponse } from "@nlc/shared-types";

import { BanknoteIcon, TicketIcon } from "lucide-react";

import { dateFormatter } from "@/utils/dateFormatter";

// The subscription backend does not expose discounts yet, so the card falls
// back to the discount shown in the Figma frame. Set it to null to preview the
// no-discount state, and drop the fallback once the endpoint fills
// upcomingPayment.discount.
const MOCK_DISCOUNT = { label: "10% off" };

export function UpcomingPaymentCard({
  data,
}: {
  data: SubscriptionOverviewResponse;
}) {
  const { upcomingPayment } = data;
  const discount = upcomingPayment.discount ?? MOCK_DISCOUNT;

  return (
    <div className="min-w-0 inline-flex flex-col justify-between gap-md rounded-xl border border-border-secondary bg-bg-primary py-xl px-3xl">
      <div className="flex items-start justify-between gap-xl">
        <div className="flex min-w-0 flex-col gap-xs">
          <h3 className="text-sm font-medium text-text-secondary">
            Upcoming payment
          </h3>
          <p className="text-4xl font-bold text-text-primary">
            {formatAmount(upcomingPayment.amount, upcomingPayment.currency)}
          </p>
        </div>
        <div className="h-10 w-10 shrink-0 rounded-md bg-bg-brand-secondary flex items-center justify-center">
          <BanknoteIcon className="text-text-brand-primary" size={20} />
        </div>
      </div>

      <div className="mt-xl flex flex-col gap-xs">
        {discount && (
          <div className="flex items-center gap-xs text-text-success-primary">
            <TicketIcon size={16} />
            <span className="text-sm font-medium">{discount.label}</span>
          </div>
        )}
        <p className="text-sm text-text-secondary">
          Renewal date: {dateFormatter(upcomingPayment.renewalDate)}
        </p>
      </div>
    </div>
  );
}

function formatAmount(amount: string, currency: string): string {
  const parsedAmount = Number(amount);

  if (Number.isNaN(parsedAmount)) return amount;

  return new Intl.NumberFormat("en-US", {
    currency,
    style: "currency",
  }).format(parsedAmount);
}
